import { BlocksIconLock } from 'blocks-nextjs/blocks-web-components/components/icon/icons/lock';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconLock = createComponent({ react: React, tagName: 'cat-icon-lock', elementClass: BlocksIconLock });
